import styles from "./VideoCallRating.styles.scss";
import {Body} from "../typography";
import Rating from "../Rating/Rating";
import Margin from "../Margin/Margin";
import Button from "../Button/Button";
import {Row} from "../Layout/Layout";

const VideoCallRating = ({videoRating, serviceRating, onChangeVideoRating, onChangeServiceRating, onSubmit}) => {
  return <div className={styles.container}>
    <Body center weight={600}>Obrigado por participar da chamada!</Body>
    <Margin top={16} />
    <Body center>Como foi o seu atendimento?</Body>
    <Margin top={8} />
    <Rating onChange={onChangeServiceRating} value={serviceRating} />
    <Margin top={16} />
    <Body center>Como foi a qualidade da chamada de vídeo?</Body>
    <Margin top={8} />
    <Rating onChange={onChangeVideoRating} value={videoRating} />
    <Margin top={16} />
    <Row horizontalCenter>
      <Button title="Submeter" onClick={onSubmit} />
    </Row>
  </div>;
};

export default VideoCallRating;



// WEBPACK FOOTER //
// ./components/VideoCallRating/VideoCallRating.js